import { CommunityIcon, DialogIcon, PeopleIcon } from 'components/Icons';
import AssembleiaIcon from 'components/Icons/AssembleiaIcon';
import { ITopBarMenuItem } from 'components/__SHARED__/TopBar/TopBarMenuItem';
import { ITopBarSubMenuItem } from 'components/__SHARED__/TopBar/TopBarSubMenuItem';
import { AssembleiaTipo } from 'helpers/enums/AssembleiaTipo';
import { TopBarMenuAcessoRapido } from 'helpers/enums/TopBarMenuAcessoRapido';
import {
  AssembleiaAssessorRoutePath,
  MensagensAssessorRoutePath,
  QuorumRoutePath,
  RelatorioPresentesRoutePath,
} from 'library/Routes';
import translation from 'locales/translation';
import { IAuthUserPerfil } from 'store/modules/auth/IAuthUserPerfil';

export const getAcessoRapido = (
  t: any,
  perfil: IAuthUserPerfil,
  currPage: TopBarMenuAcessoRapido,
  strEventoId: string,
  tipo?: AssembleiaTipo
): ITopBarMenuItem[] => {
  const menus: ITopBarMenuItem[] = [];
  const subMenu: ITopBarSubMenuItem[] = [];

  if (
    currPage !== TopBarMenuAcessoRapido.Assembleias &&
    perfil.assessorRoute.assembleias.ver
  ) {
    subMenu.push({
      label: translation.SubMenus.assembleia,
      path: AssembleiaAssessorRoutePath.replace(':id', `${strEventoId}`)
        .split(':type')
        .join('pre'),
      icon: AssembleiaIcon,
    });
  }

  if (
    currPage !== TopBarMenuAcessoRapido.Mensagens &&
    (perfil.assessorRoute.duvidasSugestoes.ver ||
      (!perfil.assessorRoute.duvidasSugestoes.ver &&
        perfil.id === 'pertencer_consulta' &&
        tipo === 'REU'))
  ) {
    subMenu.push({
      label: translation.SubMenus.mensagens,
      path: MensagensAssessorRoutePath.replace(':idEvento', `${strEventoId}`),
      icon: DialogIcon,
    });
  }

  if (
    currPage !== TopBarMenuAcessoRapido.Presentes &&
    perfil.assessorRoute.assembleias.participantes.verTotal
  ) {
    subMenu.push({
      label: translation.SubMenus.presentes,
      path: RelatorioPresentesRoutePath.replace(
        ':idAssembleia',
        `${strEventoId}`
      ),
      icon: PeopleIcon,
    });
  }

  if (
    currPage !== TopBarMenuAcessoRapido.Quorum &&
    perfil.assessorRoute.quorum.ver
  ) {
    subMenu.push({
      label: translation.SubMenus.quorum,
      path: QuorumRoutePath.replace(':idAssembleia', `${strEventoId}`),
      icon: CommunityIcon,
    });
  }

  menus.push({
    label: translation.SubMenus.acessoRapido,
    subItems: subMenu,
  });

  return menus;
};
